<div class="panel panel-primary animated fadeIn">
  <div class="panel-body">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="card mx-4">
          <div class="card-body p-4">
            <h2>Profile</h2>
            <p></p>
            <form novalidate>
            <div class="input-group mb-3">
                <span class="input-group-addon"><i class="icon-lock"></i></span>
              <input type="password" class="form-control" autofocus placeholder="Current password">
            </div>

            <div class="input-group mb-3">
              <span class="input-group-addon">
                <i class="icon-lock"></i>
              </span>
              <input type="password" class="form-control" placeholder="Password">
            </div>

            <div class="input-group mb-4">
              <span class="input-group-addon">
                <i class="icon-lock"></i>
              </span>
              <input type="password" class="form-control" placeholder="Repeat password">
            </div>

            <button type="button" class="btn btn-block btn-success">Mudar</button>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="app flex-row align-items-center">
  <div class="container">
   
  </div>
</div> -->

  </div>
</div>